export default "__VITE_ASSET__CB62W6Lp__"